import { Link } from "react-router-dom";

import { translations } from './../../../../i18/translations.js';

const AdministrationLinkRow = ({lang}) => {


    return (
            <p className="link-row mb-5">
                <Link to="/JuniorManagement" className="content-view-link">{translations[lang].junior_management}</Link>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <Link to="/MembershipManagement" className="content-view-link">{translations[lang].membership_management}</Link>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <Link to="/AggregateReport" className="content-view-link">{translations[lang].aggregate_report}</Link>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <Link to="/MembershipReportByYear" className="content-view-link">{translations[lang].membership_report}</Link>
            </p>
            );
};

export default AdministrationLinkRow;